import { BASE_API } from './constantes';

export const buildFileUrl = (relativePath) => {
  if (!relativePath) return '';
  const normalizedPath = relativePath.startsWith('/')
    ? relativePath.slice(1)
    : relativePath;
  return `${BASE_API}/${normalizedPath}`;
};

export const getDisplayFileName = (path) => {
  if (!path) return '';
  const segments = path.split('/');
  const fileName = segments[2] || segments[segments.length - 1] || path;
  return fileName.length > 32 ? fileName.slice(32) : fileName;
};

export const isPdfFile = (path) => {
  if (!path) return false;
  return /\.pdf$/i.test(path.split('?')[0].split('#')[0]);
};

export const shouldPreviewAsPdf = (path) => {
  if (!path) return false;
  const cleanPath = path.split('?')[0].split('#')[0];
  if (isPdfFile(cleanPath)) return true;
  const extension = cleanPath.split('.').pop()?.toLowerCase();
  const knownNonPdfExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'webp', 'xls', 'xlsx', 'csv', 'doc', 'docx'];
  return !extension || !knownNonPdfExtensions.includes(extension);
};
